// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37JiG","left":"styles_left__2oH1i","desktopActions":"styles_desktopActions__T0NYD","title":"styles_title__284U8"};